import axios from "axios";
import store from "@/store";
let token = store.state.seguridad.token;  
 
var BASE_URL = window.location.origin; // ayuda a obtener el dominio que se este ejecutando

if (process.env.NODE_ENV == "production") {

 BASE_URL = `${BASE_URL}${process.env.VUE_APP_SEGURIDAD_SS}`;

}else{

 BASE_URL = process.env.VUE_APP_SEGURIDAD_SS;
  
}

const baseURL = BASE_URL; 

//const baseURL =process.env.VUE_APP_SEGURIDAD_SS;
 

axios.interceptors.request.use(
  config => {
    const token = store.state.seguridad.token;
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export default axios.create({
  baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`
  }
});




 



 